import { render, staticRenderFns } from "./PlacementsNew.vue?vue&type=template&id=4bd741e6&scoped=true&"
import script from "./PlacementsNew.vue?vue&type=script&lang=ts&"
export * from "./PlacementsNew.vue?vue&type=script&lang=ts&"
import style0 from "./PlacementsNew.vue?vue&type=style&index=0&id=4bd741e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd741e6",
  null
  
)

export default component.exports